import type { Metric } from "web-vitals";
import api from "../services/api";

export const sendToAnalytics = async (metric: Metric) => {
  try {
    await api.post(
      `/metrics`,
      {
        ...metric,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
  } catch (error) {
    console.error("Erro ao enviar métricas:", error);
  }
};
